"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateAgent = exports.getAgent = exports.addAgent = exports.getAgents = void 0;
const _ = require("lodash");
const getAgents = async (supabase) => {
    const { data, error } = await supabase
        .from("agent_accounts")
        .select(`*`)
        .order("created_at", { ascending: true });
    if (!error)
        return data;
    return error;
};
exports.getAgents = getAgents;
const addAgent = async (supabase, agent) => {
    const { data, error } = await supabase
        .from("agent_accounts")
        .insert(agent)
        .single();
    if (!error)
        return data;
    return error;
};
exports.addAgent = addAgent;
const getAgent = async (supabase, id) => {
    const { data, error } = await supabase
        .from("agent_accounts")
        .select(`*,
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name)`)
        .eq("id", id)
        .single();
    if (!error)
        return data;
    return error;
};
exports.getAgent = getAgent;
const updateAgent = async (supabase, obj) => {
    const updateObj = _.cloneDeep(obj);
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id)
        updateObj.modified_by = user?.id;
    delete updateObj.created_by_user;
    delete updateObj.modified_by_user;
    const { data, error } = await supabase
        .from("agent_accounts")
        .update(updateObj)
        .eq("id", updateObj.id)
        .select(`*,
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name)`)
        .single();
    if (!error)
        return data;
    return error;
};
exports.updateAgent = updateAgent;
